import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { fetchedDebtors } from "../../../apis/apis.accounting/apisCash";
import Select from "react-select";

export function AccountReceiveSearch({
    setDebtorItem,
    debtorItem,
    setDates,
    dates,
    getAllAccountReceiveList,
    getClientsWithDebt,
    debtors,
}) {
    const [selectedOption, setSelectedOption] = useState(null);

    function handleSelectDateChange(e) {
        setDates({ ...dates, [e.target.name]: e.target.value });
    }

    const handleSelectChange = async (selectOption) => {
        setSelectedOption(selectOption);
        if (!selectOption) return;
        setDebtorItem({
            ...debtorItem,
            debtorClientID: selectOption.value,
            debtorClientName: selectOption.clientName,
            debtorClientVisitDay: selectOption.clientVisitDay,
            debtorClientObservation: selectOption.clientObservation,
            debtorClientGangName: selectOption.clientGangName,
            debtorTotalPending: selectOption.totalPending,
        });
    };

    function searchAccountsReceiveList() {
        if (
            debtorItem.debtorClientID !== "0" &&
            dates.startDate !== "" &&
            dates.endDate !== ""
        ) {
            getAllAccountReceiveList();
            setSelectedOption(null);
        } else {
            toast.warn("SELECCIONE UN CLIENTE..");
        }
    }

    const downloadDebtorsExcel = async () => {
        try {
            toast.info("Descargando lista de deudores...");
            const response = await fetchedDebtors();
            const debtorsWithPending = response.filter(
                (debtor) => Number(debtor.totalPending || 0) !== 0
            );
            const excelData = debtorsWithPending.map((debtor) => ({
                "CODIGO DE RUTA": debtor.clientObservation || "",
                "NOMBRES Y APELLIDOS": debtor.clientName || "",
                "DIA DE VISITA": getVisitDayName(debtor.clientVisitDay),
                RUTA: debtor.clientGangName || "",
                SALDO: Number(debtor.totalPending || 0).toFixed(2),
            }));
            const headers = ["CODIGO DE RUTA", "NOMBRES Y APELLIDOS", "DIA DE VISITA", "RUTA", "SALDO"];
            const BOM = "\uFEFF";
            const csvContent =
                BOM +
                [
                    headers.join(","),
                    ...excelData.map((row) =>
                        headers
                            .map((header) => {
                                const value = row[header];
                                return typeof value === "string" &&
                                    (value.includes(",") || value.includes('"') || value.includes("\n"))
                                    ? `"${value.replace(/"/g, '""')}"`
                                    : value;
                            })
                            .join(",")
                    ),
                ].join("\n");
            const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", `Lista_Deudores_${new Date().toISOString().split("T")[0]}.csv`);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            toast.success(`Lista descargada (${debtorsWithPending.length} registros)`);
        } catch (error) {
            console.error("Error al descargar deudores:", error);
            toast.error("Error al descargar la lista de deudores");
        }
    };

    const getVisitDayName = (dayNumber) => {
        const days = { 0: "DOMINGO", 1: "LUNES", 2: "MARTES", 3: "MIÉRCOLES", 4: "JUEVES", 5: "VIERNES", 6: "SÁBADO" };
        return days[dayNumber] || "NO DEFINIDO";
    };

    useEffect(() => {
        getClientsWithDebt();
    }, []);

    // react-select styles adaptados a dark/light
    const selectStyles = {
        control: (base, state) => ({
            ...base,
            minHeight: "38px",
            borderColor: state.isFocused ? "#3b82f6" : "#d1d5db",
            boxShadow: state.isFocused ? "0 0 0 2px rgba(59,130,246,0.3)" : "none",
            "&:hover": { borderColor: "#3b82f6" },
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? "#3b82f6" : state.isFocused ? "#eff6ff" : "white",
            color: state.isSelected ? "white" : "#111827",
            padding: "10px",
            fontSize: "14px",
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        container: (provided) => ({ ...provided, width: "100%" }),
    };

    const inputClass =
        "w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors";

    const labelClass = "block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wide mb-1";

    return (
        <div className="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-sm">
            <div className="px-5 py-4 border-b border-gray-200 dark:border-gray-700">
                <h2 className="text-sm font-semibold text-gray-900 dark:text-white flex items-center gap-2">
                    <i className="fas fa-search text-blue-500"></i>
                    Buscar estado de cuenta
                </h2>
            </div>

            <div className="px-5 py-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-4 items-end">

                    {/* Desde */}
                    <div className="lg:col-span-2">
                        <label htmlFor="startDate" className={labelClass}>Desde</label>
                        <input
                            type="date"
                            id="startDate"
                            name="startDate"
                            value={dates.startDate}
                            onChange={handleSelectDateChange}
                            className={inputClass}
                        />
                    </div>

                    {/* Hasta */}
                    <div className="lg:col-span-2">
                        <label htmlFor="endDate" className={labelClass}>Hasta</label>
                        <input
                            type="date"
                            id="endDate"
                            name="endDate"
                            value={dates.endDate}
                            onChange={handleSelectDateChange}
                            className={inputClass}
                        />
                    </div>

                    {/* Cliente */}
                    <div className="lg:col-span-5">
                        <label htmlFor="clientSelect" className={labelClass}>Cliente</label>
                        <Select
                            inputId="clientSelect"
                            options={debtors}
                            value={selectedOption}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            styles={selectStyles}
                            placeholder="🔍 Buscar cliente por nombre..."
                            noOptionsMessage={() => "No se encontraron clientes"}
                            loadingMessage={() => "Cargando clientes..."}
                            isSearchable
                            isClearable
                            onChange={handleSelectChange}
                            formatOptionLabel={(option) => (
                                <div className="flex items-center justify-between gap-2">
                                    <span className="font-semibold flex-1">{option.clientName}</span>
                                    {option.clientObservation && (
                                        <span className="text-xs text-gray-500 bg-gray-100 px-2 py-0.5 rounded">
                                            {option.clientObservation}
                                        </span>
                                    )}
                                    <span
                                        className={`text-xs font-bold px-2 py-0.5 rounded ${
                                            option.totalPending > 0
                                                ? "bg-amber-100 text-amber-700"
                                                : "text-gray-400"
                                        }`}
                                    >
                                        {option.totalPending > 0 && (
                                            <i className="fas fa-exclamation-circle mr-1" />
                                        )}
                                        S/. {Number(option.totalPending).toFixed(2)}
                                    </span>
                                </div>
                            )}
                        />
                    </div>

                    {/* Buscar */}
                    <div className="lg:col-span-1">
                        <button
                            type="button"
                            onClick={searchAccountsReceiveList}
                            className="w-full inline-flex items-center justify-center gap-1.5 rounded-lg bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white text-sm font-medium px-4 py-2 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800"
                        >
                            <i className="fas fa-search"></i>
                            <span className="hidden sm:inline">Buscar</span>
                        </button>
                    </div>

                    {/* Descargar deudores */}
                    <div className="lg:col-span-2">
                        <button
                            type="button"
                            onClick={downloadDebtorsExcel}
                            className="w-full inline-flex items-center justify-center gap-1.5 rounded-lg bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-800 text-white text-sm font-medium px-4 py-2 transition-colors focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800"
                        >
                            <i className="fas fa-download"></i>
                            <span>Deudores CSV</span>
                        </button>
                    </div>

                </div>
            </div>
        </div>
    );
}
